<template>
    <div>
        <!--  <div style="text-align: left;">手机验证码验证,账号:<span style="color:#ed4014;font-size:16px;">{{sta.userId}}</span>,为确认是您本人操作，请完成以下验证</div> -->
        <div style="text-align: center;">为确认是您本人操作，请完成以下验证</div>
        <Divider style="margin-top:5px;" />
        <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80" @submit.native.prevent>
            <FormItem label="手机号码" prop="tel" style="text-align: left;">
                {{sta.mobileNum.replace(sta.mobileNum.substring(3,7),'****')}}
            </FormItem>
            <FormItem label="短信验证" prop="sms">
                <Row>
                    <Col span="12"> <Input v-model="formCustom.sms" placeholder="请输入验证码..." /></Col>
                    <Col span="12"><Button type="text" style="background:#F0F6FF;" @click="countDown" :disabled="!this.canClick">{{content}}</Button></Col>
                </Row>
            </FormItem>
            <FormItem>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
export default {
    data() {
        const validateSms = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入短信验证码'));
            } else {
                callback();
            }
        };
        return {
            formCustom: {
                tel: '',
                sms: '',
                smstypecode: 0,
            },
            ruleCustom: {
                sms: [
                    { validator: validateSms, trigger: 'blur' }
                ],
            },
            showtips: false,
            errmsg: '您所提交的信息有误,请重新输入',
            content: '发送验证码',
            totalTime: 60,
            canClick: true, //添加canClick
            isSend:false, //防止重复提交请求,已做了click节流处理
        }
    },
    computed: {
        ...mapGetters(['sta'])
    },
    methods: {
        countDown() {

            if (this.isSend) {
                //this.$Message.warning('短信已发送')
                return
            } else {
                this.isSend=true
                if (this.sta.mobileNum === "") {
                    this.$Message.info('登录超时,请重新登陆')
                     this.isSend = false
                    return
                }
                this.formCustom.tel = this.sta.mobileNum
                this.formCustom.smstypecode = this.$Tools.getSMSFrom().SMS_CODE_TYPE_VOLID_OLDPHONE
                regJ.reqSmsCode(this.formCustom.tel, this.formCustom.smstypecode).then(res => {
                    this.isSend=false
                    console.log(this.formCustom.tel)
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            this.$Message.info('验证码已发送')
                            console.log('验证码已发送')
                        } else {
                            this.$Message.error(res.rltdesc);
                            return
                        }
                    } else {
                        this.$Message.error(res.rtndesc);
                        return
                    }

                    if (!this.canClick) return //改动的是这两行代码
                    this.canClick = false
                    this.content = this.totalTime + 's后重新发送'
                    let clock = window.setInterval(() => {
                        this.totalTime--
                        this.content = this.totalTime + 's后重新发送'
                        if (this.totalTime < 0) {
                            window.clearInterval(clock)
                            this.content = '发送验证码'
                            this.totalTime = 60
                            this.canClick = true //这里重新开启
                        }
                    }, 1000)

                })
            }
        },
        handleSubmit(name) {
            if (this.sta.mobileNum === "") {
                this.$Message.info('登录超时,请重新登陆')
                return
            }
            this.$refs[name].validate((valid) => {
                if (valid) {
                    //this.showtips = false;
                    this.formCustom.tel = this.sta.mobileNum
                    //console.log(this.formCustom)
                    this.$emit('popCpInfo', this.formCustom);
                    //this.$Message.success('注册成功!');
                    //ajax 成功则关闭,并跳转至登录
                    //console.log(this.formCustom);
                } else {
                    this.$Message.error();
                    //this.showtips = true;
                }
            })
        },
        handleReset(name) {
            this.$refs[name].resetFields();
            this.showtips = false;
        },
    },
}
</script>
<style lang="less" scoped>
</style>